import React from "react";

const cards = [
  {
    number: '1',
    sale: 'Стратегия',
    price: 'от 5 000 $',
    oldPrice: 'от 8 000 $',
    packPrice: 'Брендинг + Стратегия',
    oldPackPrice: 'от 12 000 $',
    bg: 'bg-danger-bg',
  },
  {
    number: '2',
    sale: 'Реклама',
    price: 'от 3 000 $',
    oldPrice: 'от 5 000 $',
    packPrice: 'Digital + SMM',
    oldPackPrice: 'от 8 000 $',
    bg: 'bg-[#E0F7FF]',
  },
  {
    number: '3',
    sale: 'Контент',
    price: 'от 2 500 $',
    oldPrice: 'от 4 000 $',
    packPrice: 'Видео + Дизайн',
    oldPackPrice: 'от 6 500 $',
    bg: 'bg-[#F0EFFF]',
  },
  {
    number: '4',
    sale: 'Комплекс',
    price: 'от 10 000 $',
    oldPrice: 'от 15 000 $',
    packPrice: 'Все услуги в комплексе',
    oldPackPrice: 'от 22 000 $',
    bg: 'bg-warning-bg',
  },
];

const Icon = ({ name, size = 16 }) => {
  const common = {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "shrink-0",
  };

  const paths = {
    arrow: <><path d="M5 12h13" /><path d="m13 6 6 6-6 6" /></>,
  };

  return <svg {...common}>{paths[name]}</svg>;
};

const FlexibleMockupPacks = () => {
  return (
    <section className="bg-bg pb-14 font-[Inter,Manrope,Arial,sans-serif] text-content">
      <div className="mx-auto max-w-[1240px] px-4">
        
        {/* Шапка блока */}
        <div className="mb-8 flex flex-wrap items-end justify-between gap-4 border-b border-line pb-4">
          <div>
            <div className="mb-1 text-[10px] font-normal uppercase tracking-[.2em] text-accent">
              Тарифы
            </div>
            <h2 className="text-2xl font-light tracking-tight text-content sm:text-3xl">
              Пакеты услуг для бизнеса
            </h2>
          </div>
          
          <button className="shine inline-flex items-center gap-2 rounded-lg bg-accent px-4 py-2 text-xs font-medium text-white transition hover:bg-accent-hover">
            Индивидуальный расчет <Icon name="arrow" size={13} />
          </button>
        </div>

        {/* Сетка: 4 колонки в ряд */}
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {cards.map((card, index) => (
            <article
              key={index}
              className="group flex flex-col overflow-hidden rounded-xl border border-line-strong bg-surface transition-all duration-300 hover:border-accent-hover hover:shadow-[0_10px_30px_rgba(0,0,0,0.06)]"
            >
              {/* Верхняя часть (Пастельный фон) */}
              <div className={`flex items-center justify-between p-5 transition-colors duration-500 ${card.bg}`}>
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-surface text-lg font-bold text-content shadow-sm">
                  {card.number}
                </div>
                <span className="text-[10px] font-bold uppercase tracking-wider text-content/60">
                  {card.sale}
                </span>
              </div>

              {/* Текстовая часть и цены */}
              <div className="flex flex-1 flex-col p-5">
                <h3 className="text-[13px] font-medium text-muted">
                  Пакет услуг
                </h3>
                
                {/* Цена */}
                <div className="mt-2 flex items-baseline gap-2.5">
                  <span className="text-[26px] font-light tracking-tight text-content">
                    {card.price}
                  </span>
                  <span className="text-xs font-light text-subtle line-through">
                    {card.oldPrice}
                  </span>
                </div>

                {/* Блок с деталями пакета */}
                <div className="mt-5 flex-1 rounded-lg border border-surface-2 bg-bg p-3.5">
                  <p className="text-[11px] leading-relaxed text-muted">
                    <strong className="font-medium text-content">{card.packPrice}</strong>{' '}
                    <span className="line-through">{card.oldPackPrice}</span>
                    <br />
                    <span className="mt-1.5 block">Индивидуальный подход и адаптация под бизнес</span>
                  </p>
                </div>

                {/* Кнопка внизу */}
                <div className="mt-5">
                  <button className="flex w-full items-center justify-center gap-1.5 rounded-lg border border-line-strong bg-surface py-2.5 text-[11px] font-medium transition hover:border-[#17191d] hover:bg-[#17191d] hover:text-white">
                    Выбрать пакет
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Ссылка "Все пакеты" внизу */}
        <div className="mt-8 text-center">
          <button className="inline-flex items-center gap-2 rounded-lg border border-line-strong bg-surface px-6 py-2.5 text-xs font-medium text-content transition hover:border-accent-hover hover:text-accent-hover">
            Собрать индивидуальный пакет <Icon name="arrow" size={13} />
          </button>
        </div>
        
      </div>
    </section>
  );
};

export default FlexibleMockupPacks;